import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import {useEffect, useState} from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import {PwaPrompt} from 'react-ios-pwa-prompt-ts';
import PaddedContainer from './components/PaddedContainer';
import ErrorFallback from './pages/ErrorFallback';
import Main from './pages/Main';
import * as serviceWorker from './serviceWorker';

const updateServiceWorker = (registration: ServiceWorkerRegistration) => {
    const {waiting} = registration;

    if (!waiting) {
        window.location.reload();
        return;
    }

    waiting.postMessage({action: 'skipWaiting'});
    waiting.addEventListener('statechange', e => {
        const target = e.target as ServiceWorker;

        if (target.state === 'activated') {
            window.location.reload();
        }
    });
};

const App: React.FC = () => {
    const [updatedRegistration, setUpdatedRegistration] =
        useState<ServiceWorkerRegistration | null>(null);

    useEffect(() => {
        serviceWorker.register({
            onUpdate: setUpdatedRegistration,
        });
    }, []);

    if (updatedRegistration) {
        return (
            <>
                <AppBar position='static'>
                    <Toolbar>
                        <Typography variant='h6'>Digital ID</Typography>
                    </Toolbar>
                </AppBar>

                <PaddedContainer>
                    <Typography gutterBottom>A new version of the app is available.</Typography>

                    <Button
                        onClick={() => {
                            updateServiceWorker(updatedRegistration);
                        }}
                        variant='contained'
                        color='secondary'
                    >
                        Update
                    </Button>
                </PaddedContainer>
            </>
        );
    }

    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={() => {
                window.location.reload();
            }}
        >
            <>
                <Main />
                <PwaPrompt />
            </>
        </ErrorBoundary>
    );
};

export default App;
